var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconLodge = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.462 4.198a.83.83 0 0 1 1.076 0l9.167 7.778a.832.832 0 1 1-1.076 1.27l-.851-.722V19A2.777 2.777 0 0 1 18 21.778H8A2.777 2.777 0 0 1 5.222 19v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778zM6.889 11.11V19A1.11 1.11 0 0 0 8 20.111h10A1.11 1.11 0 0 0 19.111 19v-7.889l-6.11-5.185-6.112 5.185z",
    fill: "#1A202C",
    fillRule: "nonzero",
    stroke: "#1A202C",
    strokeWidth: 0.5
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLodge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-lodge.c63eba28.svg";
export { ForwardRef as ReactComponent };